(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wc-product-waitlist"] && !Shopify.designMode) return;
  try {
    (function () {
    var boxes = document.querySelectorAll('[data-ep-waitlist]');
    if (!boxes.length) return;

    function noteFor(box, mode) {
      return mode === 'launch' ? box.dataset.launchNote || '' : box.dataset.restockNote || '';
    }

    function applyVariant(box, input) {
      if (!input) return;
      var mode = input.dataset.waitlist || '';
      var waiting = mode === 'launch' || mode === 'restock';
      box.hidden = !waiting;
      if (!waiting) return;
      box.dataset.mode = mode;
      box.dataset.variantId = input.value || box.dataset.variantId;
      if (input.dataset.size) box.dataset.variantTitle = input.dataset.size;
      var heading = box.querySelector('[data-ep-waitlist-heading]');
      if (heading) heading.textContent = mode === 'launch' ? box.dataset.launchHeading : box.dataset.restockHeading;
      var note = box.querySelector('[data-ep-waitlist-note]');
      if (note) {
        var noteText = noteFor(box, mode);
        note.textContent = noteText;
        note.hidden = noteText === '';
      }
      var form = box.querySelector('form');
      var button = form && form.querySelector('button[type="submit"]');
      if (button && button.dataset.done === 'true') {
        button.dataset.done = 'false';
        button.disabled = false;
        button.textContent = box.dataset.buttonLabel || 'NOTIFY ME';
        if (form.elements.email) {
          form.elements.email.readOnly = false;
          form.elements.email.value = '';
        }
        var status = form.querySelector('[role="status"]');
        if (status) status.textContent = '';
      }
    }

    async function postKlaviyo(companyId, path, payload, signal) {
      var response = await fetch(
        'https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
            revision: '2026-07-15',
          },
          body: JSON.stringify(payload),
          signal: signal,
        }
      );
      if (response.ok) return;
      var detail = '';
      try {
        detail = await response.text();
      } catch (e) {
        detail = '';
      }
      var error = new Error('klaviyo');
      error.status = response.status;
      error.detail = detail;
      throw error;
    }

    boxes.forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      var form = box.querySelector('form');
      var section = box.closest('.shopify-section');
      var picker = section && section.querySelector('[data-ep-variant]');
      if (picker) {
        picker.addEventListener('change', function (event) {
          var input = event.target;
          if (!input || input.name !== 'id') return;
          applyVariant(box, input);
        });
      }

      var sticky = section && section.querySelector('.ep-sticky-btn');
      if (sticky) {
        sticky.addEventListener('click', function () {
          if (sticky.type !== 'button' || box.hidden) return;
          var email = form && form.elements.email;
          if (!email) return;
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          box.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
          email.focus();
        });
      }

      if (!form) return;
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!form.reportValidity()) return;
        var button = form.querySelector('button[type="submit"]');
        var status = form.querySelector('[role="status"]');
        if (!button || button.dataset.done === 'true' || button.disabled) return;
        var email = form.elements.email.value.trim();
        var companyId = (box.dataset.companyId || '').trim();
        if (!companyId) {
          if (status) status.textContent = box.dataset.errorMessage || '';
          return;
        }
        var original = button.textContent;
        button.disabled = true;
        button.textContent = 'SENDING…';
        if (status) status.textContent = '';
        var controller = new AbortController();
        var timeout = setTimeout(function () {
          controller.abort();
        }, 20000);
        try {
          var variantId = box.dataset.variantId;
          try {
            await postKlaviyo(
              companyId,
              'back-in-stock-subscriptions',
              {
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: { email: email },
                      },
                    },
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: '$shopify:::$default:::' + variantId,
                      },
                    },
                  },
                },
              },
              controller.signal
            );
          } catch (error) {
            var already = error.status === 409 || /already/i.test(error.detail || '');
            if (!already) throw error;
          }
          var listId = (box.dataset.listId || '').trim();
          if (listId) {
            var source =
              'West Clay product waitlist · ' +
              (box.dataset.mode || 'restock') +
              ' · ' +
              (box.dataset.productTitle || '') +
              ' · ' +
              (box.dataset.variantTitle || '');
            try {
              await postKlaviyo(
                companyId,
                'subscriptions',
                {
                  data: {
                    type: 'subscription',
                    attributes: {
                      custom_source: source,
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: email,
                            properties: {
                              wc_waitlist_product_id: box.dataset.productId || '',
                              wc_waitlist_product_title: box.dataset.productTitle || '',
                              wc_waitlist_variant_id: variantId || '',
                              wc_waitlist_variant_title: box.dataset.variantTitle || '',
                              wc_waitlist_mode: box.dataset.mode || '',
                            },
                            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                          },
                        },
                      },
                    },
                    relationships: { list: { data: { type: 'list', id: listId } } },
                  },
                },
                controller.signal
              );
            } catch (listError) {
              if (listError && listError.name === 'AbortError') throw listError;
            }
          }
          if (status) status.textContent = box.dataset.successMessage || '';
          button.textContent = 'THANK YOU';
          button.dataset.done = 'true';
          button.disabled = true;
          form.elements.email.readOnly = true;
        } catch (error) {
          if (status) status.textContent = box.dataset.errorMessage || '';
          button.disabled = false;
          button.textContent = original;
        } finally {
          clearTimeout(timeout);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
